import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useIntl } from "react-intl";
import { useNotificationCount } from "~context/NotificationCountContext/NotificationCountContext.tsx";
import { useApi } from "~hooks/apiHooks/useApi/useApi.ts";
import { useNotification } from "~hooks/useNotification";
import type { Notification } from "~types/notification.ts";
import type { DefaultOperationSuccessResponse } from "~types/response.ts";

export const useDeleteNotification = () => {
  const { formatMessage } = useIntl();
  const queryClient = useQueryClient();
  const request = useApi();
  const notification = useNotification();

  const { refetchCount } = useNotificationCount();

  return useMutation<DefaultOperationSuccessResponse, Error, string>({
    mutationFn: async (notificationKey: string) => {
      return await request(`notifications/${notificationKey}`, {
        method: "DELETE",
      });
    },
    onSuccess: (response: DefaultOperationSuccessResponse, notificationKey: string) => {
      if (response?.data && response.data.length > 0 && response.data[0]?.success === true) {
        queryClient.setQueryData<Array<Notification>>(["notifications"], (oldValues) => {
          return oldValues?.filter((item) => item.key !== notificationKey) || [];
        });
        refetchCount();
        notification.success({
          message: formatMessage({ id: "notificationsPage.delete.success" }),
          placement: "bottomRight",
        });
      }
    },
  });
};
